import { IPFontIcon } from 'baseComponents';
import { errorIcon, pendingIcon, unknownIcon, validIcon } from 'globalStyles';

export enum ValidationIconState {
  Todo = 0,
  Success = 1,
  Error = 2,
}

interface IValidationIconProps {
  status: boolean | ValidationIconState | undefined;
}

const ValidationIcon = (props: IValidationIconProps) => {
  if (props.status !== undefined) {
    if (props.status === true || props.status === ValidationIconState.Success) {
      return <IPFontIcon {...validIcon} style={{ fontSize: 20, color: 'green' }} />;
    } else if (props.status === false || props.status === ValidationIconState.Error) {
      return <IPFontIcon {...errorIcon} style={{ fontSize: 20, color: 'red' }} />;
    } else {
      return <IPFontIcon {...pendingIcon} style={{ fontSize: 20, color: 'grey' }} />;
    }
  } else {
    return <IPFontIcon {...unknownIcon} style={{ fontSize: 20 }} />;
  }
};

export default ValidationIcon;
